module.exports = __webpack_public_path__ + "img/login_bottom.99c71fa1.png";